import FormSection from "components/FormSection"

export default function FormSectionDynamic({ blok }) {
  return <FormSection heading={blok.heading} heading2={blok.heading2} eyebrow={blok.eyebrow} />
}
